/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CelebrationBalloonIcon16Light } from './CelebrationBalloonIcon16Light';
import { CelebrationBalloonIcon16Regular } from './CelebrationBalloonIcon16Regular';
import { CelebrationBalloonIcon16Solid } from './CelebrationBalloonIcon16Solid';
import { CelebrationBalloonIcon20Light } from './CelebrationBalloonIcon20Light';
import { CelebrationBalloonIcon20Regular } from './CelebrationBalloonIcon20Regular';
import { CelebrationBalloonIcon20Solid } from './CelebrationBalloonIcon20Solid';
import { CelebrationBalloonIcon24Regular } from './CelebrationBalloonIcon24Regular';
import { CelebrationBalloonIcon24Solid } from './CelebrationBalloonIcon24Solid';
import { CelebrationBalloonIcon32Regular } from './CelebrationBalloonIcon32Regular';
import { CelebrationBalloonIcon64Regular } from './CelebrationBalloonIcon64Regular';
var sizes = {
    16: {
        light: CelebrationBalloonIcon16Light,
        regular: CelebrationBalloonIcon16Regular,
        solid: CelebrationBalloonIcon16Solid,
    },
    20: {
        light: CelebrationBalloonIcon20Light,
        regular: CelebrationBalloonIcon20Regular,
        solid: CelebrationBalloonIcon20Solid,
    },
    24: {
        regular: CelebrationBalloonIcon24Regular,
        solid: CelebrationBalloonIcon24Solid,
    },
    32: {
        regular: CelebrationBalloonIcon32Regular,
    },
    64: {
        regular: CelebrationBalloonIcon64Regular,
    },
};
export var CelebrationBalloonIcon = forwardRef('CelebrationBalloonIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
